import { createFileRoute } from "@tanstack/react-router";
import { QueueScreen } from "@modules/applications/views";
import { requireAnySurface } from "./-guards";

/**
 * /staff/rounds/$roundId/queue — "À traiter", one of the round-context rail's three tabs.
 * See `staff.rounds_.$roundId.applications.tsx` for why the segment is `rounds_` (escapes
 * `staff/rounds.tsx`'s Outlet-less component while staying inside the `/staff` AppShell).
 *
 * This is US-E7-01's own queue — the coordinator's actual landing screen once she opens a round —
 * gated on EITHER staff surface for that reason (2026-09-13).
 */
export const Route = createFileRoute("/staff/rounds_/$roundId/queue")({
  beforeLoad: ({ context, location }) =>
    requireAnySurface(
      context.queryClient,
      ["round_configuration", "intake_operations"],
      location.pathname
    ),
  staticData: {
    breadcrumb: ["nav.rounds", "breadcrumb.all-rounds", "breadcrumb.queue"],
  },
  component: RoundQueueRoute,
});

function RoundQueueRoute() {
  const { roundId } = Route.useParams();
  return <QueueScreen roundId={roundId} />;
}
